
  import { defineComponent } from 'vue';
  import { mapGetters } from 'vuex';

  import DateActualDataSubtitle from '../components/common/DateActualDataSubtitle.vue';
  import CountryDashboardsChartsBlock from '../components/dashboards/country-dashboards/CountryDashboardsChartsBlock.vue';
  import CountryDashboardsFilterBlock from '../components/dashboards/country-dashboards/CountryDashboardsFilterBlock.vue';
  import CountryDashboardsIndicatorCards from '../components/dashboards/country-dashboards/CountryDashboardsIndicatorCards.vue';
  import CountryDashboardsPersonCards from '../components/dashboards/country-dashboards/CountryDashboardsPersonCards.vue';
  import CountryDashboardsTopRfSubjectsGrowthRateCharts from '../components/dashboards/country-dashboards/CountryDashboardsTopRfSubjectsGrowthRateCharts.vue';
  import DashboardsTables from '../components/dashboards/DashboardsTables.vue';
  import { DEFAULT_DASHBOARDS_FILTER } from '../constants/dashboards';
  import { COUNTRY_DASHBOARDS_VES_GETTERS_NAME } from '../store/countryDashboards/name';
  import {
    TDashboardCountryFilter,
    TDashboardCountryFilterWithOptionalYear,
    TDashboardCountryTableFilter,
  } from '../types/countryDashboards';
  import { TEventsTableFilter, TTopPartnerRating } from '../types/dashboards';

  import { DIRECTIVES_GETTERS_NAME } from '@/store/directives';

  const getIsNotEmptyValue = (value: number) => Number.isFinite(Number(value)) && Number(value) !== 0;

  export default defineComponent({
    name: 'CountryDashboardsVES',
    components: {
      CountryDashboardsFilterBlock,
      DateActualDataSubtitle,
      CountryDashboardsIndicatorCards,
      DashboardsTables,
      CountryDashboardsChartsBlock,
      CountryDashboardsPersonCards,
      CountryDashboardsTopRfSubjectsGrowthRateCharts,
    },
    data(): {
      filter: TDashboardCountryFilter;
      tableFilter: TDashboardCountryTableFilter;
      plannedEventsFilter: TEventsTableFilter;
    } {
      return {
        filter: {
          countryId: Number(this.$route.params.countryId),
          year: this.$route.query?.year ? String(this.$route.query.year) : DEFAULT_DASHBOARDS_FILTER.year,
        },
        tableFilter: {
          countryId: Number(this.$route.params.countryId),
          isSystemEvent: false,
        },
        plannedEventsFilter: {},
      };
    },
    computed: {
      getPlannedEventsRegionRfIds(): number[] {
        return this.plannedEventsFilter.subjectRfIds ?? [];
      },
      ...mapGetters({
        partnerCountryList: DIRECTIVES_GETTERS_NAME.getPartnerCountrySearchIdList,
        topRfSubjectsGrowthRate: COUNTRY_DASHBOARDS_VES_GETTERS_NAME.getTopRfSubjectsGrowthRate,
      }),
      isGrowthRateVisible(): boolean {
        if (!Array.isArray(this.topRfSubjectsGrowthRate)) return false;

        return this.topRfSubjectsGrowthRate.some(
          (item: TTopPartnerRating) =>
            getIsNotEmptyValue(item.requestedYearValue) || getIsNotEmptyValue(item.lastYearValue),
        );
      },
    },
    methods: {
      changePlannedEventsFilter(filter: TEventsTableFilter) {
        this.plannedEventsFilter = filter;
      },
      changeFilter(filter: TDashboardCountryFilterWithOptionalYear) {
        const newYear = filter.year ?? DEFAULT_DASHBOARDS_FILTER.year;
        this.filter = {
          ...filter,
          year: newYear,
        };

        this.$router.replace({
          query: {
            ...this.$route.query,
            year: newYear,
          },
        });
      },
      redirectToCountryCard(countryId: number) {
        this.$router.replace({ name: 'CountryDashboardsVES', params: { countryId } });
      },
    },
    watch: {
      partnerCountryList: {
        handler() {
          if (
            !this.partnerCountryList.map((i: { id: number }) => i.id).includes(Number(this.$route.params.countryId))
          ) {
            this.redirectToCountryCard(this.partnerCountryList[0].id);
            return;
          }
        },
      },
    },
  });
